import React from 'react'
import { View, TouchableOpacity, Platform } from 'react-native'
import { observer } from 'mobx-react-lite'
import { color } from '../../theme'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'
import { iconClose } from '../../assets/icons'
import { LightBulbSymbol } from '../../assets/icons'
//@ts-ignore
import { ReactComponent as LightBulb } from './lightBulb.svg'
import LinearGradient from 'react-native-linear-gradient'

import { useStores, save } from '@trivie/core'

export const GettingStarted = observer((props: any) => {
  const { quizStore } = useStores()
  const { setShowTutorial } = quizStore
  const { startTutorial, style, tutorialName } = props

  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={{ qat: 'getting_started_quiz_btn' }}
      style={{
        display: 'flex',
        flex: 1,
        height: 73,
        borderRadius: 20,
        paddingTop: Platform.OS === 'web' ? 2 : 0,
        ...style,
      }}
      onPress={startTutorial}
    >
      <LinearGradient
        style={{
          borderRadius: 20,
          position: 'absolute',
          bottom: Platform.OS === 'web' ? 0 : 3,
          height: '100%',
          width: '100%',
        }}
        colors={['rgb(178,0,179)', 'rgb(114,13,175)', 'rgb(53,82,177)']}
        locations={[0, 0.5, 1]}
        useAngle
        angle={80}
        angleCenter={{ x: 0.5, y: 0.5 }}
        pointerEvents={'none'}
      />
      <View
        style={{
          flexDirection: 'row',
          flex: 1,
          display: 'flex',
          paddingVertical: 8,
          paddingBottom: 11,
        }}
      >
        <View
          style={{
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 14,
            marginRight: 12,
          }}
        >
          {Platform.OS === 'web' ? <LightBulb /> : <LightBulbSymbol variant="medium/>" />}
        </View>

        <View
          style={{
            flexDirection: 'column',
            alignSelf: 'center',
            flex: 1,
          }}
        >
          <Text
            style={{ color: color.white }}
            variant="labelEmphasized"
            tx="Onboarding.gettingStarted"
            numberOfLines={2}
          />
          <Text
            variant="body1Medium"
            style={{ color: 'rgba(255,255,255,0.7)' }}
            tx="Onboarding.learnTutorial"
            txOptions={{ name: tutorialName }}
          />
        </View>
        <View
          style={{
            height: 52,
            width: 52,
            flexDirection: 'row',
            borderRadius: 10,
            justifyContent: 'flex-end',
            marginRight: Platform.OS === 'web' ? 22 : 0,
          }}
        >
          <View style={{ flexDirection: 'column', justifyContent: 'center' }}>
            <TouchableOpacity
              // @ts-ignore
              dataSet={{ qat: 'hide_getting_started_quiz_btn' }}
              onPress={() => {
                save('show_tutorial', false)
                setShowTutorial(false)
              }}
              style={{ zIndex: 1 }}
            >
              {Platform.OS === 'web' ? (
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="#fff"
                    d="M18.3 5.71a.996.996 0 00-1.41 0L12 10.59 7.11 5.7A.996.996 0 105.7 7.11L10.59 12 5.7 16.89a.996.996 0 101.41 1.41L12 13.41l4.89 4.89a.996.996 0 101.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                  />
                </svg>
              ) : (
                <View style={{ marginRight: 22 }}>
                  <SvgIcon src={iconClose} color={color.white} size={24} />
                </View>
              )}
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  )
})
